export default "__VITE_ASSET__D$o$xbwt__"